export const RESET_SCHEDA_PERSONA_ESISTENTE_VIEWLET = 'RESET_SCHEDA_PERSONA_ESISTENTE_VIEWLET';

/**
 * Get persona telefoni.
 * @function getPersonaTelefoni
 * @param {Object} data Data.
 * @returns {Object} Get querystringsearch results action.
 */
export function resetSchedaPersonaEsistenteViewlet(user_id) {
    return {
        type: RESET_SCHEDA_PERSONA_ESISTENTE_VIEWLET,
        user_id: user_id,
    };
}
